// index.html sets `window.easil = {}` before any module loads, but this module
// is also imported in non-browser (node) test contexts, where a bare
// module-scope window write is the only thing that throws. The add/delete
// helpers below are browser-only by nature and are never called without one.
if (typeof window !== "undefined") {
  window.easil = window.easil || {};
  window.easil.htmlElements = {};
}

const easilHtmlElements = {};

easilHtmlElements.add = ({ id, htmlElement }) => {
  window.easil.htmlElements[id] = {
    ...window.easil.htmlElements[id],
    innerHtml: htmlElement,
    updatedAt: Date.now()
  };
};

easilHtmlElements.delete = id => {
  delete window.easil.htmlElements[id];
};

export default easilHtmlElements;
